import React, { Component } from 'react'

export default class whiteTick extends Component {
    render() {
        return (
            
<svg  className={this.props.className} onClick={this.props.onClick} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.3346 4L6.0013 11.3333L2.66797 8" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

        )
    }
}
